import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import type { MediaFormBrandType, MediaBrandForms } from '../mediaTypes'
import AudioFormFonts from './AudioFormFont'
import AudioFormStyle from './AudioFormStyle'

const FORM_MAP: MediaBrandForms = {
  [BrandFormEnum.STYLE]: AudioFormStyle,
  ...AudioFormFonts,
}

const AudioFormBrand: MediaFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(AudioFormBrand) as typeof AudioFormBrand
